import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, MenuItem, TextField, Switch, FormControlLabel, Chip } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useAppData } from '../../../../../../../context/AppDataContext';


const LeadPriorityBadge = ({ value, callBack }) => {
    const [dialogStatus, setDialogStatus] = useState(false);
    const [inputPriority, setInputPriority] = useState(value);
    const [remark, setRemark] = useState("");

    const { masters, getMasterLabel } = useAppData();

    const handleUpdate = () => {
        if (callBack) {
            callBack({
                priority: inputPriority,
                remark: remark
            });
        }
        setDialogStatus(false);
        setRemark("");
    };

    return (
        <>
            <Chip 
                // Combines the Icon + Label: e.g., "🚨 High"
                label={`${getMasterLabel('priority', value)}`}
                onClick={callBack ? () => setDialogStatus(true) : undefined}
                onDelete={callBack ? () => setDialogStatus(true) : undefined}
                deleteIcon={callBack ? <Edit style={{ fontSize: '14px' }} /> : null}
                variant="outlined"
                className="bg-white"
                sx={{ 
                    fontWeight: 'bold',
                    cursor: callBack ? 'pointer' : 'default',
                    borderColor: '#e0e0e0',
                    '& .MuiChip-label': { px: 2 }
                }} 
            />

            {callBack && (
                <Dialog
                    open={dialogStatus}
                    onClose={() => setDialogStatus(false)}
                    fullWidth={true}
                    maxWidth="xs"
                >
                    <div className='p-3 fw-bold border-bottom'>Update Priority</div>
                    <DialogContent>
                        <div className='row mt-2'>
                            <div className='col-md-12'>
                                {/* Priority Selection */}
                                <TextField
                                    select
                                    fullWidth
                                    label="Set Priority"
                                    value={inputPriority}
                                    onChange={(e) => setInputPriority(e.target.value)}
                                    margin="normal"
                                >
                                    {masters['priority']?.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>

                                {/* Remark */}
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={2}
                                    label="Reason for priority change"
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                    margin="normal"
                                />
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions className="p-3">
                        <button className='btn btn-light' onClick={() => setDialogStatus(false)}>Cancel</button>
                        <button className='btn btn-primary' onClick={handleUpdate}>Update Priority</button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
};

export default LeadPriorityBadge;